import { CircularProgress, TextField, Typography } from '@mui/material'
import { Box } from '@mui/system'

import { styles } from './Node.styles'

export const TEST_ID = 'node'

export type Props = {
	isEdit: boolean
	isLoading: boolean
	onInputChange: (oldValue: string, newValue: string) => void
	positions: string
	subjectText?: string
	text: string
}

const Node = (props: Props) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		props.onInputChange(props.positions, event.target.value)
	}

	const ContentArea = (
		<>
			{props.isLoading ? (
				<Box display={'flex'} sx={styles.container}>
					<CircularProgress
						size={30}
						sx={styles.circularProgressIcon}
					/>
					<Typography sx={styles.loadingText}>Loading</Typography>
				</Box>
			) : props.isEdit ? (
				<TextField
					defaultValue={props.text}
					onChange={handleChange}
					inputProps={{
						'aria-label': 'prompt text',
						style: {
							fontWeight: '400',
							fontSize: '1.8rem',
						},
					}}
					multiline
					rows={2}
				/>
			) : (
				<Typography sx={styles.text}>{props.text}</Typography>
			)}
		</>
	)

	const NoSubjectNode = (
		<>
			<Box
				display={'flex'}
				sx={{
					...styles.rectangle,
					...(props.isEdit && { border: '0px' }),
				}}
				data-testid={`${TEST_ID}-container`}
			>
				{ContentArea}
			</Box>
		</>
	)

	const NodeWSubject = (
		<>
			<Box
				display={'flex'}
				sx={{
					...styles.rectangleWithSubject,
					...(props.isEdit && { border: '0px' }),
				}}
				data-testid={`${TEST_ID}-container`}
			>
				<Box sx={styles.subjectArea}>
					<Typography
						sx={{
							fontSize: '1.2rem',
						}}
					>
						{props.subjectText}
					</Typography>
				</Box>
				<Box sx={styles.contentArea}> {ContentArea} </Box>
			</Box>
		</>
	)

	return props.subjectText ? NodeWSubject : NoSubjectNode
}

export default Node
